<template>
  <cat-modal
    :id="id"
    class="cat-repeater-callout"
    :open="open"
    :heading="calloutLabel"
    :title="calloutTitle ? calloutTitle : calloutLabel"
    :showClose="panelClose"
    :closeLabel="closeCaption"
    :size="calloutSize"
    :sidepanel="!dialog"
    :help="help"
    buttonPad
    @ui-close="toggleRepeaterChild"
  >
    <slot></slot>
    <template #buttons>
      <slot name="buttons"></slot>
    </template>
  </cat-modal>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import Vue from "vue";
import CatModal from "@/components/catModal/catModal.vue";
export default defineComponent({
  name: "CatRepeaterCallout",
  components: { CatModal },
  props: {
    id: {
      type: [String, Number],
      description: "Callout ID."
    },
    open: {
      type: Boolean,
      description: "Adds class 'open' to 'cat modal'."
    },
    calloutLabel: {
      type: String,
      description: "The heading text of the callout. "
    },
    calloutTitle: {
      type: String,
      description:
        "Use by assistive technology to identify the callout. Will fallback to calloutLabel if not present. "
    },
    panelClose: {
      type: Boolean,
      default: true,
      description: "To show or hide the close repeater modal button."
    },
    closeCaption: {
      type: String,
      description: "Modal close button text label"
    },
    help: {
      type: Object,
      description: "Help details for this repeater callout."
    },
    dialog: {
      type: Boolean,
      default: false,
      description: "Repeater modal variation: dialog or side panel"
    },
    size: {
      type: String,
      description: "Values: default is medium, l (large), xl (extra-large)"
    }
  },
  computed: {
    calloutSize: function () {
      if (this.size === "l") {
        return "large";
      }
      if (this.size === "xl") {
        return "extra-large";
      }
      return null;
    }
  },
  methods: {
    toggleRepeaterChild: function (event) {
      this.$emit("ui-repeater-done", {
        event: event,
        id: this.id ? this.id : null,
        value: !this.open
      });
    }
  }
});
</script>
